let mobileMenuLoaded = false
let mobileMenuLoading = false

class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.renderMenu()
  }

  async renderMenu () {
    if (mobileMenuLoaded || mobileMenuLoading) return

    mobileMenuLoading = true

    try {
      const res = await window.BAO.sectionRenderer.fetch(
        this.dataset.sectionId,
        `${window.Shopify.routes.root}?view=mobile-menu`,
      )

      mobileMenuLoaded = true
      const newDOM = window.BAO.sectionRenderer.convertToDOM(
        res[this.dataset.sectionId],
      )
      const myself = newDOM.querySelector('mobile-menu')

      this.outerHTML = myself.outerHTML
      const newElement = document.querySelector(`mobile-menu[data-section-id="${this.dataset.sectionId}"]`)

      if (newElement) {
        newElement.addListeners()
      }
    } catch (error) {
      console.error('Error rendering mobile menu:', error)
    } finally {
      mobileMenuLoading = false
    }
  }

  addListeners () {
    if (!this.els.trigger?.exists) return

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleBack = this.handleBack.bind(this)
    this.handleDrawerChange = this.handleDrawerChange.bind(this)

    document.addEventListener('drawer-changed', this.handleDrawerChange)

    for (const trigger of this.els.trigger.elements) {
      trigger.addEventListener('click', this.handleTrigger)
    }

    for (const back of this.els.back.elements) {
      back.addEventListener('click', this.handleBack)
    }
  }

  handleTrigger (event) {
    const clickedTrigger = event.currentTarget
    if (!clickedTrigger) return

    const matchedSubMenu = this.els.submenu.elements.find(
      (submenuEl) =>
        submenuEl.dataset.handle === clickedTrigger.dataset.handle &&
        submenuEl.dataset.level === clickedTrigger.dataset.level &&
        submenuEl.dataset.topHandle === clickedTrigger.dataset.topHandle,
    )

    if (!matchedSubMenu) return

    matchedSubMenu.classList.add('drw-Drawer-active')
    matchedSubMenu.showModal()
  }

  handleBack (event) {
    const submenuEl = event.currentTarget.closest(this.els.submenu.selector)
    if (!submenuEl) return

    submenuEl.classList.remove('drw-Drawer-active')
    submenuEl.close()
  }

  handleDrawerChange () {
    for (const submenuEl of this.els.submenu.elements) {
      submenuEl.classList.remove('drw-Drawer-active')
      submenuEl.close()
    }
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
